import { render, staticRenderFns } from "./productcheck.vue?vue&type=template&id=22f65c17&"
import script from "./productcheck.vue?vue&type=script&lang=js&"
export * from "./productcheck.vue?vue&type=script&lang=js&"
import style0 from "./productcheck.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports